// src/v3/data/types.ts
var LinksCategoryId = /* @__PURE__ */ ((LinksCategoryId2) => {
  LinksCategoryId2["BlogCategory"] = "blog-category";
  LinksCategoryId2["BusinessCategory"] = "business-category";
  LinksCategoryId2["CompanyCategory"] = "our-company-category";
  LinksCategoryId2["FooterCard"] = "footer-card";
  LinksCategoryId2["HowItWorksCategory"] = "how-it-works-category";
  LinksCategoryId2["MenuCard"] = "menu-card";
  LinksCategoryId2["PartnerCategory"] = "partner-category";
  LinksCategoryId2["ShopCategory"] = "shop-category";
  LinksCategoryId2["SupportCategory"] = "support-category";
  LinksCategoryId2["WhyOuraCategory"] = "why-oura-category";
  LinksCategoryId2["ConnectCategory"] = "connect-category";
  return LinksCategoryId2;
})(LinksCategoryId || {});
export {
  LinksCategoryId
};
//# sourceMappingURL=types.mjs.map